import { useState } from 'react';
import { formatCustomerId } from '../fulfillment';
import { useApi } from '../hooks';
import { DataTable, RequestView } from './Workflow';

type Advertiser = { customer_id: string; name: string; currency: string; linked_client?: { client_id: number; client_name: string } | null };
type Unreachable = { customer_id: string; client_id: number; client_name: string };

/** Read the connected manager's advertiser list only when an admin asks for it. */
export default function GoogleAdsAccounts() {
  const [open, setOpen] = useState(false);
  const request = useApi<{ manager_account: string; accounts: Advertiser[]; unreachable?: Unreachable[] }>(open ? '/api/googleads/accounts' : null);
  return <section className="integration-setup" aria-label="Google Ads advertiser accounts">
    <h3>Advertiser accounts</h3>
    <p>Find the account name and customer ID to use on a client's Connections page.</p>
    <button type="button" className="button secondary" disabled={open && (request.loading || request.refreshing)}
      aria-expanded={open} onClick={() => open ? request.reload() : setOpen(true)}>
      {open ? request.loading || request.refreshing ? 'Reading accounts…' : 'Refresh advertiser accounts' : 'Browse advertiser accounts'}
    </button>
    {open && <RequestView request={request}>
      {request.data && <>
        <p className="integration-note">Available through manager {formatCustomerId(request.data.manager_account)}.</p>
        {!!request.data.unreachable?.length && <div className="inline-notice warning connection-notice" role="alert"><div>
          <p>{request.data.unreachable.length === 1 ? 'This linked account is' : 'These linked accounts are'} no longer under the manager, so NOLA can't sync or change {request.data.unreachable.length === 1 ? 'it' : 'them'}. Link {request.data.unreachable.length === 1 ? 'it' : 'them'} to manager {formatCustomerId(request.data.manager_account)} again in Google Ads.</p>
          <ul>{request.data.unreachable.map(u => <li key={u.customer_id}>{u.client_name} ({formatCustomerId(u.customer_id)})</li>)}</ul>
        </div></div>}
        <DataTable columns={['account', 'customer_id', 'client']} empty="No enabled advertiser accounts are available through this Google connection."
          rows={request.data.accounts.map(a => ({ id: a.customer_id, account: a.name || 'Unnamed advertiser', customer_id: formatCustomerId(a.customer_id), client: a.linked_client?.client_name || 'Not linked' }))} />
      </>}
    </RequestView>}
  </section>;
}
